export default __webpack_public_path__ + "static/media/Warglory Helm.7855726f.jpg";